export const copyToClipboard = (str: string) => {
	if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
		return navigator.clipboard.writeText(str);
	}
	return Promise.reject('The clipboard API is not available.')
};